import { ObservablePropertyDescriptorObject } from "@yulintu/freesia-bootstrap";
export default ObservablePropertyDescriptorObject;